import { Box, Typography } from '@mui/material';
import React from 'react';
export const DropElement = (props) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            padding: 1,
            border: '1px solid #3b97e3',
            borderRadius: 1,
            color: '#000000',
            backgroundColor: 'rgba(59, 151, 227, 0.05)',
        } },
        props.icon && React.createElement(Box, { sx: { display: 'flex' } }, props.icon),
        React.createElement(Typography, { component: 'div', sx: { ml: 1 } }, props.label)));
};
